<div
		copoVirtualScroller
		[dataId]="dataId"
		#scroller="copoVirtualScroller"
		(moreDataNeeded)="onMoreDataNeeded($event.index, $event.limit, $event.provideData)"
		class="copo-no-user-select sidenav-content copo-order-tracking-block"
		@routeAnimation
		cdkScrollable>
	<div class="order-tracking-list-title" translate>datacenter.schedule-business-order</div>
	<div class="order-tracking-grid copo-container">
		<a *ngFor="let order of scroller.list" class="card-block copo-clickable" [routerLink]="['/order-tracking/schedule-business-order/card', order.supplierOrderNumber]" mat-ripple>
			<div class="order-tracking-list-card-header">
				<span class="order-tracking-list-card-header-title">{{ order.customerOrderNumber }}</span>
				<span class="order-tracking-list-card-header-ton">{{ getBusinessStatus(order) }}</span>
			</div>
			<div class="order-tracking-list-card-informations-block">
				<div class="order-tracking-list-card-information-block">
					<span class="order-card-label" translate>{{getProductType()}}</span>
					<span class="order-card-value">{{ getProductName(order) }}</span>
				</div>
				<div class="order-tracking-list-card-information-block">
					<span class="order-card-label" translate>schedule-business-order-filter.customer-article-reference</span>
					<span class="order-card-value">{{ order | copoModelInfo:'customerArticleReference' }}</span>
				</div>
			</div>
		</a>
		<copo-loading-spinner *ngIf="scroller.loading"></copo-loading-spinner>
		<div translate class="empty-page-text" *ngIf="!scroller.loading && scroller.list.length === 0">order-tracking.no.result</div>
	</div>
</div>